import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = {
  class: "text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0",
  role: "row"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 1,
  class: "totalsum"
}
const _hoisted_10 = {
  key: 0,
  class: "font-weight-boldest"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas" }, null, -1)
const _hoisted_12 = {
  key: 2,
  class: "totalsum"
}
const _hoisted_13 = { class: "odd" }
const _hoisted_14 = {
  colspan: "7",
  class: "dataTables_empty"
}
const _hoisted_15 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "\n          col-sm-12 col-md-5\n          d-flex\n          align-items-center\n          justify-content-center justify-content-md-start\n        " }
const _hoisted_20 = {
  key: 0,
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_21 = ["value"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: "25" }, "25", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "50" }, "50", -1)
const _hoisted_25 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "\n          col-sm-12 col-md-7\n          d-flex\n          align-items-center\n          justify-content-center justify-content-md-end\n        " }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", {
        class: _normalizeClass([[_ctx.loading && 'overlay overlay-block'], "\n          table\n          align-middle\n          table-row-dashed\n          fs-6\n          gy-5\n          dataTable\n          no-footer\n        "]),
        id: "kt_customers_table",
        role: "grid"
      }, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
              return (_openBlock(), _createElementBlock("th", {
                key: i,
                onClick: ($event: any) => (
                  _ctx.sort(
                    cell.sortingField ? cell.sortingField : cell.key,
                    cell.sortable
                  )
                ),
                class: _normalizeClass([
                  cell.name && 'min-w-125px',
                  cell.sortable !== false && 'sorting',
                  _ctx.tableHeader.length - 1 === i && 'text-center',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}desc` &&
                    'sorting_desc',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}asc` &&
                    'sorting_asc',
                ]),
                tabindex: "0",
                rowspan: "1",
                colspan: "1",
                style: {"cursor":"pointer"}
              }, _toDisplayString(cell.name), 11, _hoisted_4))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_5, [
          (_ctx.getItems.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getItems, (item, i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i,
                  class: "odd"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: i,
                      class: _normalizeClass({ 'text-center': _ctx.tableHeader.length - 1 === i })
                    }, [
                      (cell.key === 'game')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("Game." + item[cell.key])), 1))
                        : _createCommentVNode("", true),
                      (cell.currency)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$n(Number(item[cell.key]))), 1))
                        : _createCommentVNode("", true),
                      (cell.text)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item[cell.key]), 1))
                        : _createCommentVNode("", true),
                      (cell.customslot)
                        ? _renderSlot(_ctx.$slots, `cell-${cell.key}`, {
                            key: 3,
                            row: item
                          }, () => [
                            _createTextVNode(_toDisplayString(item), 1)
                          ])
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ]))
              }), 128))
            : _createCommentVNode("", true),
          (_ctx.columnSum)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: i,
                    class: _normalizeClass({ 'text-center': _ctx.tableHeader.length - 1 === i })
                  }, [
                    (cell.currency && cell.columnSum)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _hoisted_11,
                          _createTextVNode(" " + _toDisplayString(_ctx.$n(_ctx.sumColumn(_ctx.getItems, cell.key))), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.customColumnSum)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
                  return (_openBlock(), _createElementBlock("td", { key: i }, [
                    (cell.customColumnSum)
                      ? _renderSlot(_ctx.$slots, `columnsum-${cell.key}`, {
                          key: 0,
                          items: _ctx.getItems
                        })
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("template", null, [
            _createElementVNode("tr", _hoisted_13, [
              _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.emptyTableText), 1)
            ])
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        (_ctx.enableItemsPerPageDropdown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("label", null, [
                _createElementVNode("select", {
                  value: _ctx.pagination.rowsPerPage,
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args)))
                }, _hoisted_25, 40, _hoisted_21)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_el_pagination, {
          "current-page": _ctx.pagination.page,
          "onUpdate:current-page": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination.page = $event)),
          onCurrentChange: _ctx.currentPageChange,
          "page-size": _ctx.pagination.rowsPerPage,
          layout: "prev, pager, next",
          total: Number(_ctx.total) > 0 ? _ctx.total : _ctx.pagination.total,
          "hide-on-single-page": true,
          background: ""
        }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
      ])
    ])
  ]))
}